<div class="error-view">
    <h1>{{'error.subTitle' | translate}}</h1>
    <h3 *ngIf="code && message">{{ code }} - {{ message }}</h3>
    <div [innerHTML]="'error.text' | translate"></div>
</div>
